import React, { useState } from "react";
import Chart from "react-apexcharts";
import {
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const BookingSourceChart = ({ bookingSources = {} }) => {
  const [selectedPeriod, setSelectedPeriod] = useState("Current Year");

  const categories = Object.keys(bookingSources);
  const values = Object.values(bookingSources);

  const series = [
    {
      name: "Revenue",
      data: values,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        distributed: true,
        borderRadius: 6,
      },
    },

    colors: [
      "#3cd188",
      "#efae4e",
      "#4b7bec",
      "#f7666e",
      "#9b59b6",
      "#00cfe8",
      "#ff9f43",
      "#7367f0",
    ],

    stroke: {
      show: true,
      width: 5,
      colors: ["transparent"],
    },

    xaxis: {
      categories,

      axisTicks: {
        show: false,
      },

      axisBorder: {
        show: false,
      },

      title: {
        text: "Booking Source",
        style: {
          color: "#78909C",
          fontSize: "12px",
          fontWeight: 400,
        },
      },

      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },

    yaxis: {
      min: 0,

      title: {
        text: "Revenue",
      },

      labels: {
        formatter: (value) =>
          `₹${Number(value).toLocaleString()}`,
      },
    },

    fill: {
      opacity: 1,
    },

    legend: {
      show: false,
    },

    tooltip: {
      y: {
        formatter: (value) =>
          `₹${Number(value).toLocaleString()}`,
      },
    },

    dataLabels: {
      enabled: false,
    },

    grid: {
      borderColor: "#f1f1f1",
      strokeDashArray: 4,
    },
  };

  return (
    <Card className="card-height-100">
      <CardHeader className="align-items-center d-flex">
        <h4 className="card-title mb-0 flex-grow-1">
          Revenue By Source
        </h4>

        <div className="flex-shrink-0">
          <UncontrolledDropdown>
            <DropdownToggle
              tag="a"
              className="text-reset dropdown-btn"
              role="button"
            >
              <span className="fw-bold text-uppercase fs-12">
                Sort by:
              </span>

              <span className="text-muted ms-1">
                {selectedPeriod}
                <i className="mdi mdi-chevron-down ms-1"></i>
              </span>
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-end">
              {[
                "Today",
                "This Week",
                "This Month",
                "Current Year",
              ].map((period) => (
                <DropdownItem
                  key={period}
                  active={selectedPeriod === period}
                  onClick={() => setSelectedPeriod(period)}
                >
                  {period}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </CardHeader>

      <CardBody>
        <Chart
          options={options}
          series={series}
          type="bar"
          height={350}
        />
      </CardBody>
    </Card>
  );
};

export default BookingSourceChart;